module.exports = __webpack_public_path__ + "static/media/Himanshu_Kumar.a3b4af7e.jpg";